import type { useAuth0 } from '@auth0/auth0-react';
import type { QueryClient } from '@tanstack/react-query';
import { createRouter } from '@tanstack/react-router';
import type { PermissionsResponseDTO } from '@tempo-io/id-dto';
import type { LDClient } from 'launchdarkly-js-client-sdk';
import { NotFoundError } from '@/common/components/error/NotFoundError';
import { RouteErrorComponent } from '@/common/components/error/RouteErrorComponent';
import type { FlagKeys } from '@/common/providers/featureFlagProvider';
// biome-ignore lint/style/noRestrictedImports: the router context needs the singleton at init; all other code must use useQueryClient()
import { queryClient } from '@/common/queryClient';
import { routeTree } from './routeTree.gen';

export type RouterContext = {
  auth: ReturnType<typeof useAuth0> | null;
  queryClient: QueryClient;
  flagOverrides: Partial<FlagKeys>;
  ldClient: LDClient | undefined;
  permissions: Partial<PermissionsResponseDTO>;
};

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 30_000,
  defaultNotFoundComponent: NotFoundError,
  defaultErrorComponent: RouteErrorComponent,
  scrollRestoration: true,
  context: {
    queryClient,
    auth: null,
    flagOverrides: {},
    ldClient: undefined,
    permissions: {},
  },
  getScrollRestorationKey: (location) => {
    const pathRegexes = [/user-management\/(users|invites)$/];
    return pathRegexes.some((regex) => regex.test(location.pathname))
      ? location.pathname
      : `${location.pathname}${location.search}${location.hash}`;
  },
});
